var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('nav',{staticClass:"pull-left"},[_c('ul',[_c('li'),_c('li'),_c('li')])]),_c('div',{staticClass:"copyright pull-right"})])])
}]

export { render, staticRenderFns }